module.exports = __webpack_public_path__ + "img/editalEletronicoCell.7e17723d.jpg";